import { render } from "./Treeview.vue?vue&type=template&id=06d93fcd&ts=true"
import script from "./Treeview.vue?vue&type=script&lang=ts"
export * from "./Treeview.vue?vue&type=script&lang=ts"

import "./Treeview.vue?vue&type=style&index=0&id=06d93fcd&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__